import { render, staticRenderFns } from "./addLicenseDialog.vue?vue&type=template&id=ffc23034&scoped=true"
import script from "./addLicenseDialog.vue?vue&type=script&lang=js"
export * from "./addLicenseDialog.vue?vue&type=script&lang=js"
import style0 from "./addLicenseDialog.vue?vue&type=style&index=0&id=ffc23034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc23034",
  null
  
)

export default component.exports